import 'whatwg-fetch';
import { DeveloperProfile } from './components/profile';

import './styles/global.css';
import './styles/tailwind.css';

export default DeveloperProfile;
